import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { LayoutGrid, CheckCircle, Wrench, AlertTriangle, Power, Settings } from 'lucide-react';
import type { UtilityStats } from '../types/utility.types';

export function UtilityKpiGrid({ stats, isLoading }: { stats?: UtilityStats; isLoading: boolean }) {
  const total = stats?.totalSystems || 0;
  
  const kpis: KpiItem[] = [
    { 
      title: 'Tổng hệ thống', 
      value: total, 
      icon: LayoutGrid, 
      color: 'text-blue-600', 
      bg: 'bg-blue-50', 
      suffix: 'Hệ thống',
      trend: 'neutral',
      trendValue: 'Tổng quan',
      chartColor: 'bg-blue-500',
      chartData: [5, 5, 5, 5, 5]
    },
    { 
      title: 'Đang hoạt động', 
      value: stats?.activeCount || 0, 
      icon: CheckCircle, 
      color: 'text-emerald-600', 
      bg: 'bg-emerald-50', 
      suffix: total > 0 ? `${Math.round(((stats?.activeCount || 0) / total) * 100)}%` : '0%',
      trend: 'up',
      trendValue: 'Ổn định',
      chartColor: 'bg-emerald-500',
      chartData: [8, 9, 10, 10, 10]
    },
    { 
      title: 'Đang lắp đặt', 
      value: stats?.installingCount || 0,
      icon: Settings, 
      color: 'text-indigo-600', 
      bg: 'bg-indigo-50', 
      suffix: 'Mới',
      trend: 'up',
      trendValue: 'Triển khai',
      chartColor: 'bg-indigo-500',
      chartData: [0, 1, 0, 0, 0]
    },
    { 
      title: 'Cần bảo trì', 
      value: stats?.maintenanceDueCount || 0, 
      icon: Wrench, 
      color: 'text-orange-600', 
      bg: 'bg-orange-50', 
      suffix: 'Định kỳ',
      trend: 'down',
      trendValue: 'Theo kế hoạch',
      chartColor: 'bg-orange-500',
      chartData: [1, 2, 1, 1, 1]
    },
    { 
      title: 'Sự cố', 
      value: stats?.faultyCount || 0, 
      icon: AlertTriangle, 
      color: 'text-rose-600', 
      bg: 'bg-rose-50', 
      suffix: 'Gấp',
      trend: 'down',
      trendValue: 'Cần xử lý',
      chartColor: 'bg-rose-500',
      chartData: [0, 0, 1, 0, 0]
    },
    { 
      title: 'Không hoạt động', 
      value: Math.max(0, total - (stats?.activeCount || 0) - (stats?.faultyCount || 0)), 
      icon: Power, 
      color: 'text-slate-600', 
      bg: 'bg-slate-100', 
      suffix: 'Tạm ngưng',
      trend: 'neutral',
      trendValue: 'Ngắt',
      chartColor: 'bg-slate-500',
      chartData: [0, 0, 0, 0, 0]
    },
  ];

  return <KpiGrid kpis={kpis} isLoading={isLoading} />;
}
